"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportPhoto = void 0;
const core_shared_1 = require("@ikegps/core-shared");
const i18n_1 = require("../../../i18n");
const store_1 = require("../../../store");
const ImageWithTitle_1 = require("../components/ImageWithTitle");
const TitleBar_1 = require("../components/TitleBar");
const ReportHelpers_1 = require("../ReportHelpers");
const ReportBase_1 = require("./ReportBase");
class ReportPhoto extends ReportBase_1.ReportBase {
    constructor(poles) {
        super(poles);
    }
    buildPDF() {
        this.poles.forEach((pole, i) => {
            const job = store_1.AppStore.Tag.get(pole.jobId);
            // Title
            const poletitle = new TitleBar_1.TitleBar(pole.title || (0, i18n_1.Translate)(i18n_1.T.COLLECTION_MISSING_TITLE), job.name, i + 1, this.poles.length);
            let isFirstCaptureForPole = true;
            pole.forEachField((field) => {
                // Normal and True Size images
                if (field instanceof core_shared_1.CollectionModelFieldTrueSize || field instanceof core_shared_1.CollectionModelFieldImage) {
                    const isTrueSizeField = field instanceof core_shared_1.CollectionModelFieldTrueSize;
                    const captures = field.getCaptures();
                    captures.forEach((capture, j) => {
                        if (!(0, ReportHelpers_1.isCaptureHidden)(pole, capture.objectId)) {
                            const imageReferenceString = (0, ReportHelpers_1.captureReferenceString)(pole, capture);
                            const hasCrop = pole.getCropParameterState(capture.objectId).useInExportCorrections();
                            // Use composite for TrueSize fields (measurements) or when crop is set, otherwise use medium (zoom)
                            this.images[imageReferenceString] =
                                isTrueSizeField || hasCrop ? (0, ReportHelpers_1.compositeURL)(pole, capture) : capture.medium.url;
                            const imgReference = { reference: imageReferenceString };
                            // If the image doesnt have any measurements, attach the timestamp to the image
                            if (!(0, ReportHelpers_1.hasUserMeasurement)(pole, capture.objectId)) {
                                imgReference.timeStamp = new Date(capture.createdAt);
                            }
                            this.nodes.push(new ImageWithTitle_1.ImageWithTitle(field.schema.displayName, imgReference, {
                                sectionTitle: isFirstCaptureForPole ? poletitle : undefined,
                                pageBreak: i === 0 && isFirstCaptureForPole ? 'none' : 'before',
                            }));
                            isFirstCaptureForPole = false;
                        }
                    });
                }
            });
        });
    }
}
exports.ReportPhoto = ReportPhoto;
//# sourceMappingURL=ReportPhoto.js.map